import { createConfigSelector } from '@americanexpress/travel-selectors';

export const getAkamaiDomain = createConfigSelector('akamaiDomain');
